import { DatePipe } from '@angular/common'

import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'
import { Empresa } from '../../pkw-data/core/empresa.model'
import { RemoteFilter } from '../../pkw-data/core/util/remote-filter.interface'

export class FiltroExtrato implements RemoteFilter {
    static datePipe = new DatePipe('pt')

    inicio?: Date
    fim?: Date
    empresa?: Empresa
    operadora?: OperadoraDeMaquina
    agrupador?: number

    constructor(
        inicio?: Date,
        fim?: Date,
        empresa?: Empresa,
        operadora?: OperadoraDeMaquina,
        agrupador?: number
    ) {
        this.inicio = inicio
        this.fim = fim
        this.empresa = empresa
        this.operadora = operadora
        this.agrupador = agrupador
    }

    toFilter(): any {
        const filter: any = {}

        if (this.inicio) {
            filter.inicio = FiltroExtrato.datePipe.transform(this.inicio, 'y-MM-dd')
        }
        if (this.fim) {
            filter.fim = FiltroExtrato.datePipe.transform(this.fim, 'y-MM-dd')
        }
        if (this.empresa) {
            filter.idDaEmpresa = this.empresa.id
        }
        if (this.operadora) {
            filter.idDaOperadora = this.operadora.id
        }
        if (this.agrupador) {
            filter.agrupador = this.agrupador
        }


        return filter
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/shared/filtro-extrato.ts